<script>
    import ProvinceMunicipality from '../purchases/ProvinceMunicipality'
    import VoucherPartecipantCountry from '../purchases/VoucherPartecipantCountry'
    import VoucherPartecipantPhonePrefix from '../purchases/VoucherPartecipantPhonePrefix'

    export default {
        name: 'FiscalFileForm',
        props: ['mainForm', 'routeTabs', 'showButton'],
        components: {
            ProvinceMunicipality,
            VoucherPartecipantCountry,
            VoucherPartecipantPhonePrefix
        },
        data() {
            const form = this.mainForm
            const loggedIn = _.isNumber(form.id) && form.id > 0

            return {
                passwordShown: false,
                passwordVerifyShown: false,
                form,
                loggedIn,
                loading: false,
                email_message: '',
                email_exists: false,
                days: [
                    {value: undefined, text: 'Giorno'}
                ],
                hasAlreadyBought: false,
                months: [
                    {value: undefined, text: 'Mese'},
                    {value: 0, text: 'Gennaio'},
                    {value: 1, text: 'Febbraio'},
                    {value: 2, text: 'Marzo'},
                    {value: 3, text: 'Aprile'},
                    {value: 4, text: 'Maggio'},
                    {value: 5, text: 'Giugno'},
                    {value: 6, text: 'Luglio'},
                    {value: 7, text: 'Agosto'},
                    {value: 8, text: 'Settembre'},
                    {value: 9, text: 'Ottobre'},
                    {value: 10, text: 'Novembre'},
                    {value: 11, text: 'Dicembre'}
                ],
                years: [
                    {value: undefined, text: 'Anno'}
                ],
                types: [
                    {value: 0, text: 'qualcun altro'},
                    {value: 1, text: 'per me'}
                ]
            }
        },
        watch: {
            'form.fiscal_file.nationality': {
                handler(val) {
                    const cc = this.getCountryComponent()
                    if(cc) {
                        if(val == 'italian' || val == 'foreign') {
                            let selectVal = null
                            if (val == 'italian') {
                                selectVal = 'ITALIA'
                            }

                            if(selectVal) {
                                const $select = cc.getSelect()
                                $select.val(selectVal)
                                cc.setSelectedValue(selectVal)
                            }
                            
                            this.$set(this.form.fiscal_file, 'state', selectVal)

                            this.changedCountry(selectVal)
                        }
                    }
                }
            },
            'form.fiscal_file.state': {
                handler(val) {
                    if(val) {
                        this.changedCountry(val)
                    }
                }
            },
            'form.fiscal_file.province': {
                handler(val) {                    
                    if(val) {
                        this.changedProvince(val)
                    }
                }
            },
            'form.fiscal_file.municipality': {
                handler(val) {
                    if(val) {
                        this.changedMunicipality(val)
                    }
                }
            },
            'form.fiscal_file.phonePrefix': {
                handler(val) {
                    if(val) {
                        this.changedPrefix(val)
                    }
                }
            },
        },
        mounted() {
            if(this.form.fiscal_file.phone) {
                this.adjustPhoneByObject(this.form.fiscal_file)
            }

            this.$bus.$on('user_logged_in', (user) => {
                this.$set(this, 'loggedIn', true)

                if (user.has_already_bought) {
                    this.$emit('update-tab', 'payment')
                }
                
                this.initSelectedValuesByUser(user)
            });

            this.$bus.$on('submit-billing', () => {
                this.onSubmit()
            })
        },
        methods: {
            onGeoChanged({
                key,
                value,
                component
            }) {
                if(key == 'country') {
					key = 'state'
				} else if(key == 'prefix') {
                    key = 'phonePrefix'

                    this.$set(this.form, key, value)
                }

                this.$set(this.form.fiscal_file, key, value)

                if(key == 'phonePrefix') {
                    this.changedPrefix(value)
                } else if(key == 'province') {
                    this.changedProvince(value)
                } else if(key == 'municipality') {
                    this.changedMunicipality(value)
                } else if(key == 'country') {
                    this.changedCountry(value)
                }
            },
            changedCountry(val) {
                if(val) {
                    const countryComponent = this.getCountryComponent()
                    if(countryComponent) {
                        countryComponent.setSelectedValue(val)

                        const $select = countryComponent.getSelect()
                        $select.val(val)
                    }
                }
            },
            changedProvince(val) {
                if(val) {
                    const provinceComponent = this.getProvinceComponent()
                    if(provinceComponent) {
                        provinceComponent.setSelectedValue(val)

                        const $select = provinceComponent.getSelect()
                        $select.val(val)

                        const provinceSelectedId = $select.find("option").filter(function() {
                            return $(this).val() == val
                        }).data("id")

                        provinceComponent.valueChanged(provinceSelectedId)
                    }
                }
            },
            changedMunicipality(val) {
                if(val) {
                    const municipalityComponent = this.getMunicipalityComponent()
                    if(municipalityComponent) {
                        municipalityComponent.setSelectedValue(val)

                        const $select = municipalityComponent.getSelect()
                        $select.val(val)
                    }
                }
            },
            changedPrefix(val) {
                if(val) {
                    const phonePrefix = this.getPhonePrefixComponent()
                    if(phonePrefix) {
                        phonePrefix.setSelectedValue(val)

                        const $select = phonePrefix.getSelect()
                        $select.val(val)
                    }
                }
            },
            adjustPhoneByObject(obj) {
                if(obj.phone) {
                    const pp = obj.phone.split(" ")
                
                    if(pp.length == 2) {
                        this.$set(this.form, 'phonePrefix', pp[0])
                        this.$set(this.form.fiscal_file, 'phonePrefix', pp[0])
                        
                        this.$set(this.form, 'phone', pp[1])
                        this.$set(this.form.fiscal_file, 'phone', pp[1])
                    }
                } else {
                    this.$set(this.form, 'phonePrefix', "+39")
                    this.$set(this.form.fiscal_file, 'phonePrefix', "+39")
                }
            },
            initSelectedValuesByUser(user = null) {
                if(user) {
                    this.loggedIn = true

                    this.form.setAllData(user)

                    this.$set(this.form.fiscal_file, 'email', user.email)
                    this.$set(this.form.fiscal_file, 'phone', user.phone)

                    if(user.fiscal_file.state) {
                        this.$set(this.form.fiscal_file, 'state', user.fiscal_file.state)
                        this.$set(this.form.fiscal_file, 'nationality', user.fiscal_file.state == 'ITALIA' ? 'italian' : 'foreign')
                        $("#inlineRadio" + (user.fiscal_file.state == 'ITALIA' ? 'National' : 'Foreign')).trigger("click")
                    }

                    if(user.fiscal_file.province) {
                        this.$set(this.form.fiscal_file, 'province', user.fiscal_file.province)
                    }

                    if(user.fiscal_file.municipality) {
                        this.$set(this.form.fiscal_file, 'municipality', user.fiscal_file.municipality)
                    }

                    this.adjustPhoneByObject(user.fiscal_file)
                }
            },
            getCountryComponent() {
                return this.$refs.countrycomponent
            },
            getProvinceMunicipalityComponent() {
                return this.$refs.provincemunicipality
            },
            getProvinceComponent() {
                const pm = this.getProvinceMunicipalityComponent()
                if(pm) {
                    return pm.getProvinceComponent()
                }

                return null
            },
            getMunicipalityComponent() {
                const pm = this.getProvinceMunicipalityComponent()
                if(pm) {
                    return pm.getMunicipalityComponent()
                }

                return null
            },
            getPhonePrefixComponent() {
                return this.$refs.prefixcomponent
            },
            getSelectedValueCountry() {
                const cc = this.getCountryComponent()
                if(cc) {
                    return cc.getSelectedValue()
                }
                    
                return ''
            },
            getSelectedValueProvince() {
                const pc = this.getProvinceComponent()
                if(pc) {
                    return pc.getSelectedValue()
                }

                return ''
            },
            getSelectedValueMunicipality() {
                const mc = this.getMunicipalityComponent()
                if(mc) {
                    return mc.getSelectedValue()
                }

                return ''
            },
            getSelectedValuePhonePrefix() {
                const pp = this.getPhonePrefixComponent()
                if(pp) {
                    return this.getPhonePrefixComponent().getSelectedValue()
                }
                
                return ''
            },
            setSelectedValueCountry() {                
                this.$set(this.form.fiscal_file, 'state', this.form.fiscal_file.nationality == 'italian' ? 'ITALIA' : this.getSelectedValueCountry())
            },
            setSelectedValueProvince() {
                this.$set(this.form.fiscal_file, 'province', this.form.fiscal_file.nationality == 'foreign' ? '' : this.getSelectedValueProvince())
            },
            setSelectedValueMunicipality() {                
                this.$set(this.form.fiscal_file, 'municipality', this.getSelectedValueMunicipality())
            },
            setSelectedValuePhonePrefix() {
                const prefix = this.getSelectedValuePhonePrefix()
                
                this.$set(this.form, 'phonePrefix', prefix)
                this.$set(this.form.fiscal_file, 'phonePrefix', prefix)
            },
            adjustFormData() {
                this.$set(this.form.fiscal_file, 'email', this.form.email)
                this.$set(this.form.fiscal_file, 'phone', this.form.phone)
                
                this.setSelectedValueCountry()
                this.setSelectedValueProvince()
                this.setSelectedValueMunicipality()
                this.setSelectedValuePhonePrefix()
            },
            showPassword() {
                this.passwordShown = true
            },
            hidePassword() {
                this.passwordShown = false
            },
            showVerifyPassword() {
                this.passwordVerifyShown = true
            },
            hideVerifyPassword(e) {
                this.passwordVerifyShown = false
            },
            onBack() {
                if (this.form.isEvent) {
                    this.$emit('update-tab', 'summary')
                } else {
                    if (this.form.has_already_bought) {
                        this.$emit('reset-sub-tab')
                    } else {
                        this.$emit('update-tab', 'cart')
                    }
                }
            },
            onSubmit() {
                this.adjustFormData()

                let data = this.form.data()

                if (this.form.isEvent) {
                    $("#spinner-modal").modal()
                }

                this.form
                    .submit('post', route('fiscalFiles.validate'), {}, true)
                    .then(response => {
                        this.$emit('update-form-data', { data })

                        if (typeof this.form.total !== 'undefined') {
                            if (this.form.isEvent) {
                                let idx = _.findIndex(this.routeTabs, r => r == 'account')
                                this.$emit('update-tab', this.routeTabs[idx+1])

                                $("#spinner-modal").modal('hide')                                
                            } else {
                                if (this.form.total <= 0) {
                                    this.$emit('update-tab', 'confirm')
                                } else {
                                    if (! this.form.has_already_bought) {
                                        let idx = _.findIndex(this.routeTabs, r => r == 'billing')
                                        this.$emit('update-tab', this.routeTabs[idx+1])
                                    } else {
                                        this.$emit('reset-sub-tab')
                                        this.$emit('update-tab', 'payment')
                                    }
                                }
                            }
                        }

                        this.scrollOnTop()
                    })
                    .catch((error) => {
                        if (this.form.isEvent) {
                            $("#spinner-modal").modal('hide')
                        }

                        console.log(error)
                        this.scrollOnTop()
                        window.alerts.error("Si è verificato un errore, riprova")
                    })
            },
            openLoginModal() {
                $('#login_modal').modal();
            },
        },
    }
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/FiscalFileForm.vue